import { debounce } from "lodash";
import { useCallback, useState } from "react";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { socialClubSelector } from "@/domains/auth/slice";
import useSignInPin from "@/domains/auth/hooks/useSignInPin.ts";
import AuthSocialClub from "@/domains/auth/components/AuthSocialClub";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthSignInPin from "@/domains/auth/components/sign-in/AuthSignInPin.tsx";

export default function AuthSignInPinContainer() {
  const socialClub = useAppSelector(socialClubSelector);
  const { pending, error, setError, onSubmit } = useSignInPin();
  const [pin, setPin] = useState<string>("");

  const onPinChange = useCallback((value: string) => {
    setError("");
    setPin(value);
  }, []);

  const onSubmitHandler = useCallback(
    debounce(async () => {
      try {
        await onSubmit(pin);
        setPin("");
        await AuthMpProvider.goToAccount();
      } catch (e) {
        setPin("");
      }
    }, 300),
    [pin],
  );

  return (
    <>
      <AuthTitle>Вход в игру</AuthTitle>
      {socialClub && <AuthSocialClub socialClub={socialClub} />}
      <AuthSignInPin
        pin={pin}
        onPinChange={onPinChange}
        pending={pending}
        onSubmit={onSubmitHandler}
        error={error}
      />
    </>
  );
}
